// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"a5c64c1a","177":"5428c96a","288":"4d3d0dcf","480":"676699e0","972":"c2e4feb2"}[chunkId] + ".chunk.js";
};